import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {AbstractItem} from '@business/base/abstract-item';
import {AbstractItemService} from '@business/base/abstract-item.service';
import {AuthServer} from '@services/auth-server.service';
import {ConfigService} from '@services/webFeeder/config.service';
import {WorkspaceNewService} from '@services/workspace-new.service';
import {Constants} from '@utils/constants';
import {distinctUntilChanged, Subscription} from "rxjs";
import {debounceTime} from "rxjs/operators";

@Component({
  selector: Constants.WINDOW_NAME_POSITION_BALANCE,
  templateUrl: './position-balance-wks.component.html'
})
export class PositionBalanceWksComponent extends AbstractItem implements OnInit, OnDestroy {

  @Input() override data: any;
  protected override workspaceService: WorkspaceNewService;
  override dialog: MatDialog;
  title = Constants.TITLE_CARD_POSITION_BALANCE;
  removeFromWksTooltip = Constants.TOOLTIP_REMOVE_WKS_TOOL;
  msgOfflineNegotiation = Constants.MSG_OFFLINE_NEGOTIATION_01;
  loading = true;
  isLoggedNegotiation: boolean;
  whiteLabel = this._configService.getConfigWhitelabel();
  account: string;
  financialAccount: any = {};
  dateRequest: Date;
  authHbLoggedSubscription: Subscription;
  financialAccountSubscription: Subscription;

  constructor(
    _dialog: MatDialog,
    _workspaceService: WorkspaceNewService,
    _itemService: AbstractItemService,
    private _configService: ConfigService,
    private _authServer: AuthServer
  ) {
    super(_workspaceService, _dialog, _itemService);
    this.workspaceService = _workspaceService;
    this.dialog = _dialog;
  }

  ngOnInit() {
    this.authHbLoggedSubscription = this._configService.authHbLogged$.pipe(debounceTime(500), distinctUntilChanged()).subscribe(loggedNegotiation => {
      this.account = loggedNegotiation ? this._configService.getBrokerAccountSelected() : null;
      if (this.account) {
        this.getFinancialAccount(this.account);
      } else {
        this.loading = false;
      }
    });
  }

  retry() {
    if (this.account) {
      this.getFinancialAccount(this.account);
    }
  }

  ngOnDestroy() {
    if (this.authHbLoggedSubscription) {
      this.authHbLoggedSubscription.unsubscribe();
    }
    if (this.financialAccountSubscription) {
      this.financialAccountSubscription.unsubscribe();
    }
  }

  getFinancialAccount(account: any) {
    if (account) {
      this.loading = true;
      this._authServer.iNegotiation.financialAccountInformationCompl(this.account, Constants.MARKET_BOVESPA)
        .subscribe((res: any) => {
          if (res && res.length > 0) {
            this.dateRequest = new Date();
            this.financialAccount = {};
            res.forEach(element => {
              this.financialAccount.availableBalance = element.availableBalance.value ? Number(element.availableBalance.value) : 0;
              this.financialAccount.balanceProjOnline = element.balanceProjOnline.value ? Number(element.balanceProjOnline.value) : 0;
              this.financialAccount.uniqueLimit = element.uniqueLimit.value ? Number(element.uniqueLimit.value) : 0;
              this.financialAccount.totalEquity = element.totalEquity.value ? Number(element.totalEquity.value) : 0;
              this.financialAccount.initialEquity = element.initialEquity.value ? Number(element.initialEquity.value) : 0;
              this.financialAccount.balanceD0 = element.balanceD0.value ? Number(element.balanceD0.value) : 0;
              this.financialAccount.balanceD1 = element.balanceD1.value ? Number(element.balanceD1.value) : 0;
              this.financialAccount.balanceD2 = element.balanceD2.value ? Number(element.balanceD2.value) : 0;
              this.financialAccount.bmfLeveragedLimit = element.bmfLeveragedLimit.value ? Number(element.bmfLeveragedLimit.value) : 0;
              this.financialAccount.bmfLeveragedLimit = element.bmfLeveragedLimit.value ? Number(element.bmfLeveragedLimit.value) : 0;
              this.financialAccount.refiLimit = element.refiLimit.value ? Number(element.refiLimit.value) : 0;
              this.financialAccount.tediLimit = element.tediLimit.value ? Number(element.tediLimit.value) : 0;
              this.financialAccount.withdrawLimit = element.withdrawLimit.value ? Number(element.withdrawLimit.value) : 0;
              this.financialAccount.withdrawLimitUsed = element.withdrawLimitUsed.value ? Number(element.withdrawLimitUsed.value) : 0;
              this.financialAccount.bmfLimit = element.bmfLimit.value ? Number(element.bmfLimit.value) : 0;
              this.financialAccount.optionLimit = element.optionLimit.value ? Number(element.optionLimit.value) : 0;
              this.financialAccount.cashLeveragedLimit = element.cashLeveragedLimit.value ? Number(element.cashLeveragedLimit.value) : 0;
              this.financialAccount.optionsLeveragedLimit = element.optionsLeveragedLimit.value ? Number(element.optionsLeveragedLimit.value) : 0;
            });
          }
          this.loading = false;
        }, error => {
          this.loading = false;
        });
    }
  }

  resetValues() {
    this.financialAccount = {};
    this.financialAccount.availableBalance = 0;
    this.financialAccount.balanceProjOnline = 0;
    this.financialAccount.uniqueLimit = 0;
    this.financialAccount.totalEquity = 0;
    this.financialAccount.initialEquity = 0;
    this.financialAccount.balanceD0 = 0;
    this.financialAccount.balanceD1 = 0;
    this.financialAccount.balanceD2 = 0;
    this.financialAccount.bmfLeveragedLimit = 0;
    this.financialAccount.bmfLeveragedLimit = 0;
    this.financialAccount.refiLimit = 0;
    this.financialAccount.tediLimit = 0;
    this.financialAccount.withdrawLimit = 0;
    this.financialAccount.withdrawLimitUsed = 0;
    this.financialAccount.bmfLimit = 0;
    this.financialAccount.optionLimit = 0;
    this.financialAccount.cashLeveragedLimit = 0;
    this.financialAccount.optionsLeveragedLimit = 0;
  }

}
